module.exports = __webpack_public_path__ + "img/empty_profile.b942792d.svg";